
import { IOfflineCardData } from "../models/IOfflineCardData";
import { ReadType } from "../models/IReadType";
import { ICardCashless, ICardGroupDiscounts } from "domains/cashless/aggregates/ICardCashless";
import { IOrderPad } from "domains/cashless/aggregates/IOrderPad";


/** Fonte/origem dos dados do cartão (reconhecimento facial, leitor físico ou apelido) */
export enum CardDataSource {
  FacialRecognition = "FacialRecognition",
  /** Identificado por seleção em tela de rostos similares — no pagamento pede senha, não confirmação facial */
  FacialRecognitionSimilarFace = "FacialRecognitionSimilarFace",
  CardReader = "CardReader",
  NickName = "NickName",
}
export interface ICardReaderStore {
  tag: string | null;
  offlineCardData: IOfflineCardData | null;
  readError: string | null;
  cardDetected: boolean;
  isActiveSensor: boolean;
  readType: ReadType;
  
  enableSensor: (type: ReadType, cashlessCode?: string) => Promise<void>;
  clearCardReader: () => void;
  disableSensor: () => void;
  readTag: (type: ReadType, onlyUid?: boolean, disableBeep?: boolean) => Promise<void>;
  
  
  //Context states
  cardData: ICardCashless | null;
  cardDataSource?: CardDataSource | null;
  groupDiscounts: ICardGroupDiscounts[] | null;
  orderPad: IOrderPad | null;
  outOfDateError: string | null;
  readedCard: string | null;
  
  setCardData: (cardData: ICardCashless | null) => void;
  setGroupDiscounts: (groupDiscounts: ICardGroupDiscounts[] | null) => void;
  setOrderPad: (orderPad: IOrderPad | null) => void;
  setOutOfDateError: (outOfDateError: string | null) => void;
  setReadedCard: (readedCard: string | null) => void;
  setCardDataSource: (source: CardDataSource) => void;
  
  /** Quando true, não chama stop/abort após leitura (fluxo de gravação recarga offline) */
  isOfflineRechargeRecordMode: boolean;
  setOfflineRechargeRecordMode: (value: boolean) => void;
  setOfflineCardData: (offlineCardData: IOfflineCardData) => void;
  isClosed?: boolean;
  setIsClosed: (isClosed: boolean | undefined) => void;
}







//const [cardData, setCardData] = useState<ICardCashless | null>(null);
//const [groupDiscounts, setGroupDiscounts] = useState<
//  ICardGroupDiscounts[] | null
//>(null);
//const [orderPad, setOrderPad] = useState<IOrderPad | null>(null);
//const [outOfDateError, setOutOfDateError] = useState<string | null>(null);
//const [readedCard, setReadedCard] = useState<string | null>(null);
